import React from "react";

import { getIcon } from "../../helpers/icons";
import Title from "../Title";

import style from "./style.module.css";

export default function ReadTime({ time = "", type = "" }) {
    return time !== "" ? (
        <div className={`${style.time} ${ type !== "" ? style[type] : ""}`}>
            <i className={getIcon("Time")}></i>
            <Title className={type !== "" ? "textUpperCase" : ""} tag={type !== "" ? "h6" : "p"}>{time}</Title>
        </div>
    ) : null ;
}